import React, { useState } from "react";
import "./PostcodeInput.css";

const PostcodeInput = ({ nextStep, updateFormData }) => {
  const [postcode, setPostcode] = useState("");
  const [error, setError] = useState("");

  const validatePostcode = (value) => {
    // UK postcode regex pattern
    const regex = /^([A-Z]{1,2}\d{1,2}[A-Z]?)\s?\d[A-Z]{2}$/i;
    return regex.test(value.trim());
  };

  const handleSubmit = (e) => {
  window.scrollTo(0, 0);
  e.preventDefault();
  if (validatePostcode(postcode)) {
    setError("");
    updateFormData({ postcode: postcode.trim().toUpperCase() }); // Save to formData
    nextStep(); // Just go to next step without arguments
  } else {
    setError("Please enter a valid UK postcode.");
  }
};


  return (
    <div className="postcode-input-screen">
      <h2>What's your postcode?</h2>
      <p>We use your postcode to calculate accurate solar potential for your location.</p>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="e.g. SW1A 1AA"
          value={postcode}
          onChange={(e) => setPostcode(e.target.value)}
          className={error ? "error" : ""}
        />
        {error && <div className="error-message">{error}</div>}
        <button type="submit">Continue</button>
      </form>
    </div>
  );
};

export default PostcodeInput;
